import { createSelector } from '@reduxjs/toolkit';
import { storeSelector } from '../../Global/StoreSelector';

const isAuthenticated = createSelector(storeSelector, (state) => !!state.user.currentUser);
const areServicesReady = createSelector(
  storeSelector,
  (state) =>
    state.service.isTesseractLoaded &&
    state.service.isWebsocketConnected &&
    state.service.isSmoEnvironmentImageClassifierLoaded &&
    state.service.isSmoMoonTypeImageClassifierLoaded
);

export default {
  isAuthenticated,
  areServicesReady
};
